/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "1425ea5662fa87cd337b3150c7b53d1e414740b3";
